<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div
      v-if="hasPrivilege('accounting_add_sales')"
      class="modal fade"
      id="addSalesModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body p-4">
            <button
              type="button"
              id="add-sale-close"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div class="text-center mb-6">
              <h4 class="mb-2 text-success">
                {{ $t("sales.add_sales") }}
              </h4>
            </div>
            <hr class="mx-4 my-2" />

            <form
              id="upgradePlanForm"
              class="row g-4 mt-2"
              onsubmit="return false"
            >
              <div class="col-12">
                <label class="form-label" for="operationTime">{{
                  $t("sales.name")
                }}</label>
                <input type="text" v-model="sale.name" class="form-control" />
              </div>
              <div class="col-12">
                <label class="form-label" for="operationTime">{{
                  $t("sales.description")
                }}</label>
                <input
                  type="text"
                  v-model="sale.description"
                  class="form-control"
                />
              </div>
              <div class="col-12">
                <label class="form-label" for="operationTime">{{
                  $t("sales.notes")
                }}</label>
                <input type="text" v-model="sale.notes" class="form-control" />
              </div>
              <div class="col-12">
                <label class="form-label" for="price">{{
                  $t("sales.price")
                }}</label>
                <div class="input-group">
                  <input
                    type="number"
                    v-model="sale.price"
                    class="form-control"
                  />
                  <div class="input-group-text">{{ settings.currency }}</div>
                </div>
              </div>
              <div class="col-12">
                <label class="form-label" for="paid">{{
                  $t("sales.paid")
                }}</label>
                <div class="input-group">
                  <input
                    type="number"
                    v-model="sale.paid"
                    class="form-control"
                  />
                  <div class="input-group-text">{{ settings.currency }}</div>
                </div>
              </div>
              <div class="col-12 text-center mt-12">
                <button
                  class="btn btn-success me-2"
                  type="button"
                  @click="store"
                >
                  <i class="ti ti-circle-plus me-1"></i>
                  {{ $t("control.add") }}
                </button>
                <button
                  type="reset"
                  class="btn btn-label-secondary"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  {{ $t("control.cancel") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <SalesPay
      v-if="selectedSale && hasPrivilege('accounting_pay_sales')"
      :selectedSale="selectedSale"
      @updated="
        selectedSale = null;
        applyFilters();
      "
    />
    <div class="card mb-2">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#addSalesModal"
                    :class="{
                      disabled_ssr: !this.$store.getters.settings.license
                        .active,
                    }"
                    v-if="hasPrivilege('accounting_add_sales')"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{ $t("sales.add_sales") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    v-model="filters.search_query"
                    @change="applyFilters"
                    :placeholder="$t('control.search')"
                    v-if="hasPrivilege('accounting_search_sales')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6 mt-4  mt-md-0" bis_skin_checked="1">
            <div
              class="col-12 col-md-9 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                    v-model="filters.rows"
                    @change="applyFilters"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <!-- <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#bills-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div> -->
            </div>
            <div
              class="col-12 col-md-3 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('sales_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="export_csv('sales_table', 'sales')"
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('sales_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                id="sales_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th></th>
                    <th>
                      <!-- <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="defaultCheck1"
                      /> -->
                    </th>
                    <th>{{ $t("sales.id") }}</th>
                    <th>{{ $t("sales.name") }}</th>
                    <th>{{ $t("sales.description") }}</th>
                    <th>{{ $t("sales.notes") }}</th>
                    <th>{{ $t("sales.price") }}</th>
                    <th>{{ $t("sales.paid") }}</th>
                    <th>{{ $t("sales.account") }}</th>
                    <th>{{ $t("sales.user") }}</th>
                    <th>{{ $t("control.updated_at") }}</th>
                    <th>{{ $t("control.created_at") }}</th>
                  </tr>
                  <tr v-if="hasPrivilege('accounting_search_sales')">
                    <th></th>
                    <th></th>
                    <th>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.id"
                        @change="applyFilters"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.name"
                        @change="applyFilters"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.description"
                        @change="applyFilters"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        v-model="filters.notes"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <input
                        type="text"
                        v-model="filters.price"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <select
                        class="form-select"
                        @change="applyFilters"
                        v-model="filters.paid"
                      >
                        <option value="-1">{{ $t("control.all") }}</option>
                        <option value="1">{{ $t("control.yes") }}</option>
                        <option value="0">{{ $t("control.no") }}</option>
                      </select>
                    </th>
                    <th>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.account_username"
                        @change="applyFilters"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th>
                      <select
                        v-model="filters.user_id"
                        @change="applyFilters"
                        class="form-select form-select-sm"
                      >
                        <option value="-1">{{ $t("control.all") }}</option>
                        <option
                          v-for="admin in admins"
                          :key="admin.id"
                          :value="admin.id"
                          >{{ admin.email }}</option
                        >
                      </select>
                    </th>
                    <th>
                      <input
                        type="date"
                        v-model="filters.updated_at"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                      />
                    </th>
                    <th>
                      <input
                        type="date"
                        v-model="filters.created_at"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                      />
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(sale, index) in dataList" :key="sale.id">
                    <td>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li>
                            <a class="dropdown-item text-primary" href="#">
                              <i class="ti ti-printer me-2"></i
                              >{{ $t("actions.print") }}
                            </a>
                          </li>

                          <li>
                            <a
                              @click="showPaySaleDialog(sale)"
                              class="dropdown-item text-success"
                              v-if="hasPrivilege('accounting_pay_sales')"
                              href="#"
                            >
                              <i class="ti ti-cash me-2"></i
                              >{{ $t("sales.pay") }}
                            </a>
                          </li>
                          <li>
                            <a
                              class="dropdown-item text-danger"
                              v-if="hasPrivilege('accounting_delete_sales')"
                              @click="deleteSale(sale)"
                              href="#"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="sale.selected"
                        @click="selectData(sale)"
                      />
                    </td>
                    <td>{{ sale.id }}</td>
                    <td>{{ sale.name }}</td>
                    <td>{{ sale.description }}</td>
                    <td>{{ sale.notes }}</td>

                    <td>{{ sale.price + settings.currency }}</td>
                    <td>{{ sale.paid + settings.currency }}</td>
                    <td>{{ sale.account_username }}</td>
                    <td>{{ sale.user_email }}</td>
                    <td>{{ formatDate(sale.updated_at) }}</td>
                    <td>{{ formatDate(sale.created_at) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card p-4 mb-2" v-if="hasPrivilege('accounting_view_sales')">
      <div class="account-bills-total row g-3">
        <div class="col-md-4">
          <div
            class="alert alert-primary d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-receipt-2 me-2"></i>
              <strong>{{ $t("bills.total.current_grand") }}:</strong>
            </span>
            <strong>{{ current_bills + settings.currency }}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="alert alert-success d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-cash me-2"></i>
              <strong>{{ $t("bills.total.current_paid") }}:</strong>
            </span>
            <strong>{{ current_paid + settings.currency }}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="alert alert-danger d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-report-money me-2"></i>
              <strong>{{ $t("bills.total.current_debt") }}:</strong>
            </span>
            <strong>{{
              current_bills - current_paid + settings.currency
            }}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="card p-4 mb-2" v-if="hasPrivilege('accounting_view_sales')">
      <div class="account-bills-total row g-3">
        <div class="col-md-4">
          <div
            class="alert alert-primary d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-calculator me-2"></i>
              <strong>{{ $t("bills.total.total_grand") }}:</strong>
            </span>
            <strong>{{ total_bills + settings.currency }}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="alert alert-success d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-cash me-2"></i>
              <strong>{{ $t("bills.total.total_paid") }}:</strong>
            </span>
            <strong>{{ total_paid + settings.currency }}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="alert alert-danger d-flex align-items-center justify-content-between"
            role="alert"
          >
            <span>
              <i class="ti ti-report-money me-2"></i>
              <strong>{{ $t("bills.total.total_debt") }}:</strong>
            </span>
            <strong>{{ total_bills - total_paid + settings.currency }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants.js";
import { mapGetters } from "vuex";
import store from "../store/index.js";
import SalesPay from "../components/modals/sales-pay.vue";
export default {
  name: "Sales",
  components: {
    SalesPay,
  },
  data() {
    return {
      dataList: null,
      admins: null,
      meta: { last_page: 0 },
      loading: true,
      showFilters: false,
      showPayBill: false,
      showDeleteBill: false,
      selectedSale: null,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        id: "",
        name: "",
        description: "",
        notes: "",
        account_username: "",
        user_id: -1,
        created_at: "",
        updated_at: "",
        save: false,
        search_query: null,
        price: "",
        paid: -1,
      },
      sale: {
        id: null,
        name: "",
        description: "",
        notes: "",
        price: 0,
        paid: 0,
      },
      pdfOptions: {
        margin: 5,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: { scale: 1, dpi: 96, letterRendering: true },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "p",
        },
      },
      format: (date) => {
        const day1 = date[0].getDate();
        const month1 = date[0].getMonth() + 1;
        const year1 = date[0].getFullYear();
        const hour1 = date[0].getHours();
        const minute1 = date[0].getMinutes();

        const day2 = date[1].getDate();
        const month2 = date[1].getMonth() + 1;
        const year2 = date[1].getFullYear();

        return `${day1}-${month1}-${year1} -> ${day2}-${month2}-${year2}`;
      },
      exportFilename: "accounts.pdf",
      total_bills: 0,
      total_paid: 0,
      current_bills: 0,
      current_paid: 0,
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      loading_overlay: false,
      report_loading: false,
      reportReady: false,
      report: null,
      server_url: localStorage.getItem("server"),
      reportDateStart: "",
      reportDateEnd: "",
      showNotificationConfirm: false,
      notificationMessage: "",
    };
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  async created() {
    this.prepareFilters();
    if (this.$route.query.username_debt) {
      this.filters.account_username = this.$route.query.username_debt;
      this.filters.paid = "0";
    }
    if (this.$route.query.username) {
      this.filters.account_username = this.$route.query.username;
    }
    this.applyFilters();
    this.fetchTotal();
    this.fetchAdmins();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    prepareFilters() {
      var filters = localStorage.getItem("sales_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    async applyFilters() {
      console.log(this.filters.updated_at);
      this.loading = true;
      var requestString = "sales?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.user_id != -1)
        requestString += `&user_id=${this.filters.user_id}`;
      if (this.filters.id != "") requestString += `&id=${this.filters.id}`;
      if (this.filters.account_username != "")
        requestString += `&account_username=${this.filters.account_username}`;
      if (this.filters.name != "")
        requestString += `&name=${this.filters.name}`;
      if (this.filters.notes != "")
        requestString += `&notes=${this.filters.notes}`;
      if (this.filters.price != "")
        requestString += `&price=${this.filters.price}`;
      if (this.filters.paid != "-1")
        requestString += `&paid=${this.filters.paid}`;
      if (this.filters.description != "")
        requestString += `&description=${this.filters.description}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.filters.created_at != "")
        requestString += `&created_at=${this.filters.created_at}`;
      if (this.filters.updated_at != "")
        requestString += `&updated_at=${this.filters.updated_at}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem("sales_filters", JSON.stringify(this.filters));
      this.current_bills = 0;
      this.current_paid = 0;
      this.dataList.forEach((bill) => {
        this.current_bills += bill.price;
        this.current_paid += bill.paid;
      });
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0,
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0,
          );
        }
      }
      this.meta = response.data.meta;
      this.loading = false;
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   this.dataList = response.data.data;
      //   if (this.filters.save)
      //     localStorage.setItem("sales_filters", JSON.stringify(this.filters));
      //   this.current_bills = 0;
      //   this.current_paid = 0;
      //   this.dataList.forEach((bill) => {
      //     this.current_bills += bill.price;
      //     this.current_paid += bill.paid;
      //   });
      //   if (this.dataList.length < 1 && this.filters.page != 1) {
      //     this.filters.page = 1;
      //     this.applyFilters();
      //   }
      //   if (this.sort_col) {
      //     if (this.sort_dir == "ASC") {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] > b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] > a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     } else {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] < b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] < a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     }
      //   }
      //   this.meta = response.data.meta;
      //   this.loading = false;
      // }, 1000);
    },
    async fetchTotal() {
      const response = await axios.get("sales/total");
      if (response.status == 200) {
        this.total_bills = response.data.data.total_bills;
        this.total_paid = response.data.data.total_paid;
      }
    },
    async fetchAdmins() {
      const response = await axios.get("adminslog/admins?itr=true");
      if (response.status == 200) {
        this.admins = response.data.data;
      }
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    formatDate(date) {
      return moment(date).format("yyyy-MM-DD hh:mm a");
    },
    async store() {
      this.loading = true;
      const response = await axios.post("sales", this.sale);
      if (response.status == 200) {
        document.getElementById("add-sale-close").click();
        this.$notify({
          text: this.$t("sales.new_sale_added"),
          type: "success",
        });
        this.applyFilters();
        this.sale = {
          id: null,
          name: "",
          description: "",
          notes: "",
          price: 0,
          paid: 0,
        };
        this.loading = false;
      }
    },
    async deleteSale(sale) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("sales.this_will_delete_sale_record"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("sales.yes_delete"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`sales/${sale.id}`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("sales.deleteted"),
              text: this.$t("sales.sale_has_been_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            console.log(error);

            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async showPaySaleDialog(sale) {
      this.selectedSale = sale;
      await this.$nextTick();
      var modalElement = document.getElementById("paySalesModal");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    },

    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    isValidDate() {
      var dateStringS = this.reportDateStart;
      var dateStringE = this.reportDateEnd;
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      const result =
        dateStringS.match(regEx) != null && dateStringE.match(regEx) != null;
      if (result) {
        this.fetchReport();
      }
    },
    async fetchReport() {
      this.report_loading = true;
      const response = await axios.get(
        `bills/report?report_date_start=${this.reportDateStart}&report_date_end=${this.reportDateEnd}`,
      );
      if (response.status == 200) {
        this.report = response.data.data;
        this.report.sum = response.data.sum;
        this.report.count = response.data.count;
        this.reportReady = true;
      }
      this.report_loading = false;
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("sales_filters", JSON.stringify(this.filters));
    },
    print_element(element_id) {
      // Get HTML to print from element
      const prtHtml = document.getElementById(element_id).innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          <link href="/js/about.js" rel="prefetch">
          <link href="/styles/app.scss" rel="stylesheet">
          <link href="/styles/main.css" rel="stylesheet">
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
